// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + {"4008":"my-posts-page-modals","4287":"post-actions"}[chunkId] + ".chunk.min.css";
};